import styled from "styled-components";

export const HistoryTable = styled.div`  
 width: 100%;
 display: flex;
 justify-content: space-between;
 flex-direction: row;

  .tableHeaderLabels{
    width: 595px;
    display: grid;
    margin: 18px 0;
    grid-template-columns: 123px 87px 132px 107px 147px;

    p{
      color: #858585;
      font-size: 12px;
      padding-left: 14px;
    }
  }

  .renderRows{
    padding: 18px 0;
    width: 595px;
    height: 295px;
    border-radius: 6px;
    overflow: hidden scroll;
    background-color: #FFFFFF;

    .noHistory{
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      p{
        color: #364863;
        font-weight: 800;
      }
    }
  }
`;